import { Box, Heading, Section, Text } from "@vinomofo/components";
import { useState } from "react";

import { Review } from "../../types";
import { SwipeableIndicator } from "../swipeable-indicator";
import SwipeableViews from "react-swipeable-views";
import { WineReview } from "./WineReview";
import { autoPlay } from "react-swipeable-views-utils";

export interface WineReviewsProps {
  reviews: Array<Review>;
  heading: string;
  subheading: string;
}

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

export const WineReviews = ({
  reviews,
  subheading,
  heading,
}: WineReviewsProps): JSX.Element => {
  const [currentReviewIndex, setCurrentReviewIndex] = useState(0);

  return (
    <Section
      // marginTop={["20px", "40px", "70px"]}
      py={["50px", "50px", "75px"]}
      backgroundColor="almostWhite"
      id="hero-scroll-stop"
    >
      <Box textAlign="center" marginBottom={["40px", "40px", "60px"]}>
        <Box>
          <Text
            variant="sm"
            fontWeight="500"
            fontFamily="heading"
            color="primary"
          >
            {subheading}
          </Text>
        </Box>
        <Heading as="h4" variant="xl">
          {heading}
        </Heading>
      </Box>
      <AutoPlaySwipeableViews
        index={currentReviewIndex}
        interval={10000}
        onChangeIndex={(i) => setCurrentReviewIndex(i)}
        enableMouseEvents
      >
        {reviews.map((review, i) => (
          <WineReview key={i} review={review} />
        ))}
      </AutoPlaySwipeableViews>

      {reviews.length > 1 && (
        <SwipeableIndicator
          dots={reviews.length}
          currentIndex={currentReviewIndex}
          onChangeIndex={(i) => setCurrentReviewIndex(i)}
        />
      )}
    </Section>
  );
};
